import { useState } from 'react';
import { useMessage } from '@dealstack/frontend/app/pages/Project/MIP/hooks/useMessage';
import { useTranslationMipMessages } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { DetailedMessage } from '@dealstack/frontend/app/pages/Project/MIP/Messages/components/DetailedMessage/DetailedMessage';
import { MessagesList } from '@dealstack/frontend/app/pages/Project/MIP/Messages/components/MessagesList/MessagesList';
import { useMessagesDealSwitcher } from '@dealstack/frontend/app/pages/Project/MIP/Messages/hooks/useMessagesDealSwitcher';
import { FlexExtended } from '@dealstack/frontend/shared/components/Flex/FlexExtended';
import { GenericError } from '@dealstack/frontend/shared/pages/GenericError/GenericError';
import { useMantineTheme } from '@mantine/core';
import { MessagesBreadcrumbs } from '@dealstack/frontend/app/pages/Project/MIP/Messages/components/Breadcrumbs/MessagesBreadcrumbs';
import { useDeals } from '@dealstack/frontend/shared/modules/deal/hooks/useDeals';
import { useDeal } from '@dealstack/frontend/shared/modules/deal/hooks/useDeal';
import { BreadcrumbsProvider } from '@dealstack/frontend/shared/components/Breadcrumbs/useBreadcrumbs';
import { useRequiredParams } from '@dealstack/frontend/shared/utils/useRequiredParams';
import { PageHeader } from '@dealstack/frontend/shared/layout/PageHeader/PageHeader.tsx';
import { PageContainer } from '@dealstack/frontend/shared/layout/PageContainer/PageContainer.tsx';

export const MessagesDashboard = () => {
	const tMipMessages = useTranslationMipMessages();
	const { investorId, mipId, dealId } = useRequiredParams('investorId', 'mipId', 'dealId');
	const { data: deals } = useDeals({});
	const { data: deal } = useDeal({ dealId });

	const theme = useMantineTheme();
	const [messageId, setMessageId] = useState<string | null>(null);
	const { data: message, isFetching } = useMessage({
		investorId,
		messageId: messageId as string,
		mipId,
		enabled: !!investorId && !!messageId,
	});
	useMessagesDealSwitcher({ dealId, deal, deals });

	if (!investorId || !dealId) {
		return <GenericError />;
	}

	return (
		<BreadcrumbsProvider>
			<PageContainer>
				<PageHeader pageTitle={tMipMessages('page.header')}>
					<MessagesBreadcrumbs deal={deal} dealId={dealId} mipId={mipId} />
				</PageHeader>
				<FlexExtended
					direction="row"
					border={`1px solid ${theme.colors.gray[4]}`}
					mih="calc(100vh - 13rem)"
				>
					<MessagesList
						investorId={investorId}
						messageId={messageId}
						setMessageId={setMessageId}
					/>
					<DetailedMessage message={message} isLoading={isFetching} />
				</FlexExtended>
			</PageContainer>
		</BreadcrumbsProvider>
	);
};
